import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../localization/localization.service';

@Pipe({
  name: 'appendtext'
})
export class AppendTextPipe implements PipeTransform {
  constructor(private localizationService: LocalizationService) { }

  transform(value: any, translateKey: string): string {
    return `${value} ${this.localizationService.Translate(translateKey)}`
  }


}
